import { render, staticRenderFns } from "./InfosBancaire.vue?vue&type=template&id=f9ed47ac&"
import script from "./InfosBancaire.vue?vue&type=script&lang=js&"
export * from "./InfosBancaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports